// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "MasonryGrid-module--bx--text-truncate--end--BoZpZ";
export var bxTextTruncateFront = "MasonryGrid-module--bx--text-truncate--front--7AyaP";
export var gridContainer = "MasonryGrid-module--gridContainer--+FB1o";
export var gridItem = "MasonryGrid-module--gridItem--3ICUD";
export var image = "MasonryGrid-module--image--qBQ3q";
export var masonryColumn = "MasonryGrid-module--masonryColumn--jpx0Q";
export var masonryGrid = "MasonryGrid-module--masonryGrid--SkQfM";